/**
 * Stale-response guard for a store that can have more than one in-flight load at once (e.g. a
 * live search box, or rapid filter/sort changes)
 */
export function createStaleResponseGuard() {
  let latestId = 0;

  return {
    isLatest: (id: number) => id === latestId,
    start: () => ++latestId,
  };
}
